import AbstractController from "../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController";
import Controller from "../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller";
import AjaxUtility from "../../../../../ig_template/Resources/Public/Src/Js/Utility/AjaxUtility";
import {debounce} from "chart.js/helpers";

class VipRecruitment extends AbstractController {

	constructor() {
		super();
		Controller.registerController(this);

		this.data = {
			location: null,
			memberId: '',
			memberName: ''
		}
	}

	onReady() {
		this.queryContainer = document.getElementById('member-query-results');
		this.queryLoading = document.getElementById('member-query-loading');
		this.memberIdField = document.getElementById('member-id-hidden');
		this.submitButton = document.getElementById('member-search-submit');

		this.searchBox = document.getElementById('recruitment-member-search');
		if (this.searchBox) {
			this.memberQueryRequest = null;
			this.searchBox.addEventListener('input', debounce(this.memberQuery.bind(this), 600));
		}

		const locationSelect = document.getElementById('club-selection');
		if (locationSelect) {
			locationSelect.addEventListener('change', e => {
				this.data.location = e.target.value;
				this.updateComponent();
				this.memberQuery();
			});
		}

		if (this.submitButton) {
			this.submitButton.setAttribute('disabled', 'disabled');
		}

		this.qrCodeContainer = document.getElementById('qr-code-container');
		if (this.qrCodeContainer) {
			QrCreator.render({
				text: this.qrCodeContainer.dataset.url
			}, this.qrCodeContainer);
		}

		this.waTextName = document.getElementById('wa-text-name');
		this.waRecruit = document.getElementById('wa-recruit');
		if (this.waTextName && this.waRecruit) {
			this.waTextName.addEventListener('blur', () => {
				AjaxUtility.request(5729, {
					action: 'setPreferredName',
					recruitmentLog: parseInt(this.waTextName.dataset.recruitmentlog),
					preferredName: this.waTextName.value
				}, {
					5729: 'tx_igviprecruitment_recruitmentlog'
				});
			});
			this.waRecruit.addEventListener('click', () => {
				window.open(this.waRecruit.dataset.baseurl + window.encodeURIComponent(this.waRecruit.dataset.recruitmenttext + ' ' + this.waTextName.value), '_blank');
				window.location.href = this.waRecruit.href;
			});
		}
	}

	memberQuery() {
		const searchTerm = this.searchBox.value;
		if (searchTerm.length > 3 && this.data.location) {
			if (this.memberQueryRequest !== null) {
				this.memberQueryRequest.abort();
			}

			this.queryContainer.innerHTML = '';
			this.queryLoading.style.display = '';
			this.memberQueryRequest = AjaxUtility.request(5728, {
				action: 'memberQuery',
				locationUid: this.data.location,
				searchTerm
			}, {
				5728: 'tx_igviprecruitment_recruitment'
			})
				.done(response => {
					this.queryLoading.style.display = 'none';
					this.queryContainer.innerHTML = response;
					this.addMemberQueryEventHandlers();
					this.memberQueryRequest = null;
				});
		}
	}

	addMemberQueryEventHandlers() {
		const memberSelectors = document.querySelectorAll('#member-query-container .member-selector');
		for (let i in memberSelectors) {
			if (memberSelectors.hasOwnProperty(i)) {
				let memberSelector = memberSelectors[i];
				memberSelector.addEventListener('click', () => {
					this.data.memberId = memberSelector.dataset.id;
					this.data.memberName = memberSelector.dataset.name;
					memberSelectors.forEach(selector => {
						selector.classList.remove('active');
					});
					memberSelector.classList.add('active');
					this.updateComponent();
				});
			}
		}
	}

	updateComponent() {
		if (this.data.memberName && this.data.memberId) {
			this.memberIdField.value = this.data.memberId;
			this.searchBox.value = this.data.memberName;
		}

		if (this.data.location && this.data.memberName && this.data.memberId) {
			this.submitButton.removeAttribute('disabled');
		} else {
			this.submitButton.setAttribute('disabled', 'disabled');
		}
	}
}

new VipRecruitment;
